/** Promotions screen API (store-scoped by RLS on the backend). */
import axios from 'axios';
import type { HeadersGetter } from './customers';

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:7071/api';

export interface PromoLine {
  planner_no: string;
  line_no: number;
  item_no: string | null;
  description: string | null;
  floor_plan: string | null;
  start_date: string;
  end_date: string;
  was_price: number | null;
  promo_price: number | null;
  percent_saving: number | null;
  country_name: string | null;
  vintage: string | null;
  /** This store's customers with the product tagged favourite. */
  match_count: number;
}

export interface PromoGroup {
  planner_no: string;
  promotion: string | null;
  promo_type: string | null;
  start_date: string;
  end_date: string;
  lines: PromoLine[];
}

export interface PromoMatch {
  customer_id: string;
  first_name: string | null;
  last_name: string | null;
  store_code: string;
  planner_no: string;
  item_no: string;
  product_name: string | null;
  promotion: string | null;
  floor_plan: string | null;
  start_date: string;
  end_date: string;
  was_price: number | null;
  promo_price: number | null;
  percent_saving: number | null;
  has_reminder: boolean;
}

export async function getPromotions(getHeaders: HeadersGetter, days = 30): Promise<PromoGroup[]> {
  const headers = await getHeaders();
  const res = await axios.get<{ promotions: PromoGroup[] }>(`${API_BASE}/promotions`, {
    params: { days }, headers,
  });
  return res.data.promotions;
}

export async function getPromoMatches(getHeaders: HeadersGetter, days = 30): Promise<PromoMatch[]> {
  const headers = await getHeaders();
  const res = await axios.get<{ matches: PromoMatch[] }>(`${API_BASE}/promotions/matches`, {
    params: { days }, headers,
  });
  return res.data.matches;
}

export async function addPromoReminder(
  getHeaders: HeadersGetter,
  input: { customerId: string; plannerNo: string; itemNo: string }
): Promise<void> {
  const headers = await getHeaders();
  await axios.post(`${API_BASE}/promotions/reminders`, input, { headers });
}
